import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { techRadarConfig } from './data/tech-radar-config';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: techRadarApiRef,
    deps: {},
    factory: () => ({
      load: async () => ({
        ...techRadarConfig,
        entries: techRadarConfig.entries.map(entry => ({
          ...entry,
          timeline: entry.timeline.map(timeEntry => ({
            ...timeEntry,
            date: new Date(timeEntry.date),
          })),
        })),
      }),
    }),
  }),
];
